import React, { Component } from 'react';
import { Card, CardBody, Col, FormGroup, InputGroup, Label, Input } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import { toast } from 'react-toastify';

import Lang from '../../languages';
import Config from '../../config';
import md5 from 'md5';

import './Editor.css';

class UsersProfile extends Component {
 constructor(props) {
  super(props);

  this.state = {
   laddaloading: false,
   errMessage: false,
  };

  this.setValue = this.setValue.bind(this);
  this.handleSave = this.handleSave.bind(this);
 }

 getDefault() {
  return { NID: '', userID: 0, userType: 0, email: '', username: '', passwd: '', confirmpw: '', tradename: '', taxname: '', firstname: '', surname: '', address: '', locality: '', state: '', postcode: '', country: '', phone: '', mobile: '', fax: '' }
 }

 setValue(e) {
  var newUser = this.state.user;
  newUser[e.target.id] = e.target.value;
  this.setState({ user: newUser });
 }

 handleSave() {
  var errorFileds = this.state.classNames;
  Object.keys(errorFileds).map(function (key, index) { errorFileds[key] = errorFileds[key].replace(' border border-danger', ''); });
  this.setState({ laddaloading: true, classNames: errorFileds }, () => {
   var postUser = JSON.parse(JSON.stringify(this.state.user));
   if (postUser.passwd === postUser.confirmpw) {
    if (postUser.userID < 1 && postUser.passwd === '') {
     var errorFileds = this.state.classNames;
     errorFileds.passwd = errorFileds.passwd + " border border-danger";
     errorFileds.confirmpw = errorFileds.confirmpw + " border border-danger";
     this.setState({ laddaloading: false, errMessage: Lang[this.props.session.language].Users.Errors.PassNotMatch, classNames: errorFileds });
    } else {
     if (postUser.passwd != '') {
      postUser.passwd = md5(postUser.passwd);
      delete postUser.confirmpw;
     } else {
      delete postUser.passwd;
      delete postUser.confirmpw;
     }

     this.props.reqAPI(Config.apiURI + '/api/users', 'PUT', postUser).then((result) => {
      if (result.success) {
       var classNames = {}
       var userValues = this.getDefault()
       Object.keys(userValues).map(function (key, value) { classNames[key] = "form-control" });
       this.setState({ laddaloading: false, errMessage: '', classNames });
       toast.success(Lang[this.props.session.language].Users.Alerts.profileSaved);
      } else {
       var errorFileds = this.state.classNames;
       result.failed.map((key) => { errorFileds[key] = errorFileds[key] + " border border-danger"; });
       this.setState({ laddaloading: false, errMessage: result.message, classNames: errorFileds });
      }
     }).catch((error) => {
      console.error(error);
      this.setState({ laddaloading: false });
     })
    }
   } else {
    var errorFileds = this.state.classNames;
    errorFileds.passwd = errorFileds.passwd + " border border-danger";
    errorFileds.confirmpw = errorFileds.confirmpw + " border border-danger";
    this.setState({ laddaloading: false, errMessage: Lang[this.props.session.language].Users.Errors.PassNotMatch, classNames: errorFileds });
   }
  });
 }

 componentDidMount() {
  var classNames = {}
  var userValues = this.getDefault()
  Object.keys(userValues).map(function (key, value) { classNames[key] = "form-control" });
  this.props.reqAPI(Config.apiURI + '/api/users/' + this.props.session.user.ID + '?full').then(response => {
   this.setState({
    classNames,
    user: {
     passwd: '', confirmpw: '',
     userID: parseInt(response.ID),
     userType: response.userType ? response.userType : '',
     NID: response.NID ? response.NID : '',
     email: response.email ? response.email : '',
     username: response.username ? response.username : '',
     tradename: response.tradename ? response.tradename : '',
     taxname: response.taxname ? response.taxname : '',
     firstname: response.firstname ? response.firstname : '',
     surname: response.surname ? response.surname : '',
     address: response.address ? response.address : '',
     locality: response.locality ? response.locality : '',
     state: response.state ? response.state : '',
     postcode: response.postcode ? response.postcode : '',
     country: response.country ? response.country : '',
     phone: response.phone ? response.phone : '',
     mobile: response.mobile ? response.mobile : '',
     language: response.language ? response.language : this.props.session.language
    }
   });
  })
 }

 render() {
  if (this.state.user != null) {
   return (
    <Card>
     <CardBody>
     <FormGroup row>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="username">{Lang[this.props.session.language].Users.columns.username}</Label>
           <Input type="text" id="username" autoComplete="off" value={this.state.user.username} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.username} className={this.state.classNames.username} />
          </FormGroup>
         </Col>
         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label htmlFor="passwd">{Lang[this.props.session.language].Users.columns.password}</Label>
           <Input type="password" id="passwd" value={this.state.user.passwd} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.password} className={this.state.classNames.passwd} />
          </FormGroup>
         </Col>
         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label htmlFor="confirmpw">{Lang[this.props.session.language].Users.columns.password}</Label>
           <Input type="password" id="confirmpw" value={this.state.user.confirmpw} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.password} className={this.state.classNames.confirmpw} />
          </FormGroup>
         </Col>
        </FormGroup>

        <FormGroup row>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="tradename">{Lang[this.props.session.language].Users.columns.tradename}</Label>
           <Input type="text" id="tradename" value={this.state.user.tradename} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.tradename} className={this.state.classNames.tradename} />
          </FormGroup>
         </Col>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="taxname">{Lang[this.props.session.language].Users.columns.taxname}</Label>
           <Input type="text" id="taxname" value={this.state.user.taxname} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.taxname} className={this.state.classNames.taxname} />
          </FormGroup>
         </Col>
        </FormGroup>

        <FormGroup row>
         <Col xs="4">
          <FormGroup className="form-group-clean">
           <Label htmlFor="firstname">{Lang[this.props.session.language].Users.columns.firstname}</Label>
           <Input type="text" id="firstname" value={this.state.user.firstname} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.firstname} className={this.state.classNames.firstname} />
          </FormGroup>
         </Col>
         <Col xs="5">
          <FormGroup className="form-group-clean">
           <Label htmlFor="surname">{Lang[this.props.session.language].Users.columns.surname}</Label>
           <Input type="text" id="surname" value={this.state.user.surname} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.surname} className={this.state.classNames.surname} />
          </FormGroup>
         </Col>

         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label htmlFor="NID">{Lang[this.props.session.language].Users.columns.NID}</Label>
           <Input id="NID" value={this.state.user.NID} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.NID} className={this.state.classNames.NID} />
          </FormGroup>
         </Col>
        </FormGroup>

        <FormGroup row>
         <Col xs="7">
          <FormGroup className="form-group-clean">
           <Label htmlFor="address">{Lang[this.props.session.language].Users.columns.address}</Label>
           <Input type="text" id="address" value={this.state.user.address} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.address} className={this.state.classNames.address} />
          </FormGroup>
         </Col>
         <Col xs="5">
          <FormGroup className="form-group-clean">
           <Label htmlFor="locality">{Lang[this.props.session.language].Users.columns.locality}</Label>
           <Input type="text" id="locality" value={this.state.user.locality} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.locality} className={this.state.classNames.locality} />
          </FormGroup>
         </Col>
        </FormGroup>

        <FormGroup row>
         <Col xs="4">
          <FormGroup className="form-group-clean">
           <Label htmlFor="state">{Lang[this.props.session.language].Users.columns.state}</Label>
           <Input type="text" id="state" value={this.state.user.state} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.state} className={this.state.classNames.state} />
          </FormGroup>
         </Col>
         <Col xs="2">
          <FormGroup className="form-group-clean">
           <Label htmlFor="postcode">{Lang[this.props.session.language].Users.columns.postcode}</Label>
           <Input id="postcode" value={this.state.user.postcode} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.postcode} className={this.state.classNames.postcode} />
          </FormGroup>
         </Col>
         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label htmlFor="country">{Lang[this.props.session.language].Users.columns.country}</Label>
           <Input type="text" id="country" value={this.state.user.country} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.country} className={this.state.classNames.country} />
          </FormGroup>
         </Col>
         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label htmlFor="language">{Lang[this.props.session.language].Users.columns.language}</Label>
           <Input id="language" name="select" type="select" onChange={this.setValue} value={this.state.user.language} className={this.state.classNames.language}>
            {
             Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
              return (<option key={index} value={key}>{Lang[this.props.session.language].languages[key]}</option>)
             })
            }
           </Input>
          </FormGroup>
         </Col>
        </FormGroup>

        <FormGroup row>
         <Col xs="6">
          <FormGroup className="form-group-clean">
           <Label htmlFor="email">{Lang[this.props.session.language].Users.columns.email}</Label>
           <InputGroup>
            <div className="input-group-prepend">
             <span className="input-group-text"><i className="fa fa-envelope"></i></span>
            </div>
            <Input type="text" id="email" value={this.state.user.email} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.email} className={this.state.classNames.email} />
           </InputGroup>
          </FormGroup>
         </Col>
         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label>{Lang[this.props.session.language].Users.columns.mobile}</Label>
           <InputGroup>
            <div className="input-group-prepend">
             <span className="input-group-text"><i className="fa fa-mobile"></i></span>
            </div>
            <Input id="mobile" value={this.state.user.mobile} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.mobile} className={this.state.classNames.mobile} />
           </InputGroup>
          </FormGroup>
         </Col>
         <Col xs="3">
          <FormGroup className="form-group-clean">
           <Label>{Lang[this.props.session.language].Users.columns.phone}</Label>
           <InputGroup>
            <div className="input-group-prepend">
             <span className="input-group-text"><i className="fa fa-phone"></i></span>
            </div>
            <Input id="phone" value={this.state.user.phone} onChange={this.setValue} placeholder={Lang[this.props.session.language].Users.placeholders.phone} className={this.state.classNames.phone} />
           </InputGroup>
          </FormGroup>
         </Col>
        </FormGroup>

      <div className="modal-footer">
       <div className="text-danger"><strong>{this.state.errMessage}</strong></div>
       <LaddaButton
        type="submit"
        onClick={this.handleSave}
        className="btn btn-success btn-ladda"
        data-style={EXPAND_LEFT}
        loading={this.state.laddaloading}>
        {Lang[this.props.session.language].Users.buttons.saveChanges}
       </LaddaButton>
      </div>
     </CardBody>
    </Card>
   )
  } else {
   return (
    null
   )
  }

 }

}

export default UsersProfile;



// WEBPACK FOOTER //
// ./websources/views/Users/Profile.js